import { FC, useCallback, ChangeEvent, useState, InputHTMLAttributes, ReactNode } from 'react'
import styles from 'components/features/pfm/ProviderSearchPaneDecoration/ProviderSearchPaneDecoration.styl'
import { Omit } from 'interfaces'
import CrossSvg from 'icons/cross.svg'
import SvgIcon from 'components/atoms/SvgIcon'
import { ProviderSearchInputDecoration, ProviderSearchInputDecorationProps } from 'components/features/pfm/ProviderSearchInputDecoration/ProviderSearchInputDecoration'

type DecorationStateProps = 'hasFocus' | 'hasValue'
type DecorationState = Pick<ProviderSearchInputDecorationProps, DecorationStateProps>

type ProviderSearchPaneDecorationProps =
  & {
    decorationProps: Omit<ProviderSearchInputDecorationProps, DecorationStateProps>
    inputProps?: InputHTMLAttributes<HTMLInputElement>
    onClean: () => void
    icon?: ReactNode
    inputRef?: (ref: HTMLInputElement | null) => void
  }


/*
  DEPRECATED
  Avoid using this component due to ugly interface
  Build you own components related to your task
*/

export const ProviderSearchPaneDecoration: FC<ProviderSearchPaneDecorationProps> = (props) => {
  const {
    decorationProps,
    inputProps = {},
    onClean,
    icon,
    inputRef,
  } = props
  const { onChange, onFocus, onBlur, ...restInputProps } = inputProps

  const [state, setState] = useState<DecorationState>({
    hasFocus: false,
    hasValue: false,
  })

  const handleFocus = useCallback((event) => {
    !!onFocus && onFocus(event)

    setState({
      ...state,
      hasFocus: true,
    })
  }, [state, onFocus])

  const handleBlur = useCallback((event) => {
    !!onBlur && onBlur(event)

    setState({
      ...state,
      hasFocus: false,
    })
  }, [state, onBlur])

  const handleChange = useCallback<(event: ChangeEvent<HTMLInputElement>) => void>((event) => {
    const { target } = event
    const hasValue = !!target.value
    if (state.hasValue !== hasValue) {
      setState({
        ...state,
        hasValue,
      })
    }

    onChange && onChange(event)
  }, [state, onChange])

  const [inputKey, setInputKey] = useState(0)
  const handleClean = useCallback(() => {
    setInputKey(inputKey + 1)
    setState({
      ...state,
      hasValue: false,
    })
    onClean()
  }, [inputKey, onClean, state])

  return (
    <ProviderSearchInputDecoration
      { ...decorationProps }
      { ...state }
    >
      <div className={ styles.inputWrapper }>
        <input
          key={ inputKey }
          type='text'
          ref={ inputRef }
          className={ styles.input }
          onChange={ handleChange }
          onFocus={ handleFocus }
          onBlur={ handleBlur }
          { ...restInputProps }
        />
        { !state.hasValue && !!icon && icon }
        { state.hasValue && (
          <button
            className={ styles.icon }
            onClick={ handleClean }
          >
            <SvgIcon src={ CrossSvg } />
          </button>
        )}
      </div>
    </ProviderSearchInputDecoration>
  )
}
